import { v4 as uuidv4 } from 'uuid';

import storage from './storage1';

let browserUid = storage.browser_uid;

if (!browserUid?.random_at) {
  browserUid = {
    random_at: ~~(Date.now() / 1000),
    random_id: uuidv4().replace(/-/g, ''),
  };
  storage.browser_uid = browserUid;
}

export { browserUid };
